import type { As } from "@chakra-ui/react";
import type { APIADPlatforms } from "models/types/api-listing";
import DomainLogo from "assets/icons/medium/domain-logo.svg?react";
import OnTheMarketLogo from "assets/icons/medium/on-the-market-dot-com-logo.svg?react";
import ReachLogoV2 from "assets/icons/medium/reach-logo-v2.svg?react";
import REANZLogo from "assets/icons/medium/realestate-co-nz-logo.svg?react";
import REALogo from "assets/icons/medium/realestate-dot-com-logo.svg?react";
import RightMoveLogo from "assets/icons/medium/right-move-dot-co-dot-uk-logo.svg?react";
import TradeMeLogo from "assets/icons/medium/trade-me-logo.svg?react";

export const AD_PLATFORMS: Record<
  APIADPlatforms,
  {
    name: string;
    logo: As;
    impressions_key: string | null;
    clicks_key: string | null;
  }
> = {
  au_reaapi: {
    name: "realestate.com.au",
    logo: REALogo,
    impressions_key: "listingEvents:searchResultsPageImpression",
    clicks_key: "listingEvents:pageView",
  },
  reach: {
    name: "Rex Reach",
    logo: ReachLogoV2,
    impressions_key: null,
    clicks_key: null,
  },
  au_domainapi: {
    name: "Domain",
    logo: DomainLogo,
    impressions_key: null,
    clicks_key: "totalListingViews",
  },
  nz_trademe: {
    name: "trademe",
    logo: TradeMeLogo,
    impressions_key: "NewViewCount",
    clicks_key: null,
  },
  nz_reanzapi: {
    name: "realestate.co.nz",
    logo: REANZLogo,
    impressions_key: "views",
    clicks_key: null,
  },
  uk_onthemarket: {
    name: "OnTheMarket",
    logo: OnTheMarketLogo,
    impressions_key: "summary_views.total_summary_views",
    clicks_key: "detail_views.total_detail_views",
  },
  uk_rightmove: {
    name: "Rightmove",
    logo: RightMoveLogo,
    impressions_key: "summary_views.total_summary_views",
    clicks_key: "detail_views.total_detail_views",
  },
};
